/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreSoftDeleteAttachmentDto } from '../../models/core-soft-delete-attachment-dto';

export interface ProjectSubtasksControllerSoftDeleteAttachment$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The subtask ID.
 */
  subtaskId: string;
  
    /**
     * S3 key of the attachment to delete
     */
    body: CoreSoftDeleteAttachmentDto
}

export function projectSubtasksControllerSoftDeleteAttachment(http: HttpClient, rootUrl: string, params: ProjectSubtasksControllerSoftDeleteAttachment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<{
'success'?: boolean;
}>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtasksControllerSoftDeleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('subtaskId', params.subtaskId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<{
      'success'?: boolean;
      }>;
    })
  );
}

projectSubtasksControllerSoftDeleteAttachment.PATH = '/o2-core/project-subtasks/{tenant}/subtasks/{subtaskId}/attachments';
